// Auto-generated by scripts/write-version.js. Do not edit by hand.
export const APP_VERSION = "1.19.1";
export const APP_GIT_SHA = "01d6072";
